module.exports = __webpack_public_path__ + "img/icon3.2f327026.1aac7c85.png";